<template>
  <v-card class="dashboard_wrap sales-dashboard-card">
    <section class="sales-stat-grid oms-list-stats">
      <StatCard
        class="sales-stat-card sales-stat-card--total oms-list-stat-card"
        label="Total Inquiries"
        :value="dashboard.totalOpportunities || '0'"
        caption="Open and closed demand"
        icon="inbox"
        variant="blue"
      />
      <StatCard
        class="sales-stat-card sales-stat-card--converted oms-list-stat-card"
        label="Converted Inquiries"
        :value="dashboard.convertedOpportunities || '0'"
        caption="Accepted customer rates"
        icon="check_circle"
        variant="green"
      />
      <StatCard
        class="sales-stat-card sales-stat-card--value oms-list-stat-card"
        label="Value Generated"
        :value="$formatPrice(dashboard.totalValue || 0)"
        caption="Quoted sales value"
        icon="trending_up"
        variant="yellow"
      />
      <StatCard
        v-permissions="'add-enquiry'"
        class="oms-page-action-card sales-add-inquiry-card sales-stat-card sales-stat-card--action oms-list-stat-card"
        actionable
        label="Add Inquiry"
        value="New"
        caption="Create sales opportunity"
        icon="add"
        variant="primary"
        @click="check"
      />
    </section>
    <SelectCountry
      :open="selectCountryDialog"
      @closeSelectCountry="selectCountryDialog = false"
      :type="'/inquiry/new'"
    />
  </v-card>
</template>
<script>
import SelectCountry from "../Common/SelectCountry";
import StatCard from "@/components/Common/StatCard";
export default {
  components: {
    SelectCountry,
    StatCard,
  },
  props: ["dashboard"],
  data() {
    return {
      selectCountryDialog: false,
      operation: "",
      operationName: "",
      workingCountries: [],
    };
  },
  methods: {
    async check() {
      this.operationName = "add-enquiry";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (localStorage.getItem("workingCountries")) {
          this.workingCountries = JSON.parse(
            localStorage.getItem("workingCountries")
          );
          let workingCountry = [];
          this.workingCountries.forEach((key, index) => {
            if (key.isSelected) {
              workingCountry.push(key.value);
            }
          });
          if (workingCountry.length === 1) {
            this.$router.push(`/inquiry/new`);
          } else {
            this.selectCountryDialog = true;
          }
        }
      } else {
        return;
      }
    },
    showfilter() {
      var div = document.getElementById("filter_wrap");
      div.style.display = div.style.display == "block" ? "none" : "block";
    },
  },
};
</script>
<style scoped>
.sales-dashboard-card {
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.sales-stat-grid {
  background: var(--oms-list-surface, var(--oms-surface, #ffffff));
  display: grid;
  gap: var(--oms-list-stat-gap, 1rem);
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: var(--oms-list-section-y, 1rem) var(--oms-list-section-x, 1.75rem);
}

.dashboard {
  padding: 1.25rem;
  margin: 0 auto;
}
.breakword {
  padding: 0.625rem;
}

.p-b-0 {
  padding-bottom: 0 !important;
}

.f-16 {
  font-size: 1rem !important;
}

@media (max-width: 80rem) {
  .sales-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 48rem) {
  .sales-stat-grid {
    grid-template-columns: 1fr;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
